<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    :width="width"
    :height="height"
    xml:space="preserve"
    viewBox="0 0 60 60"
    role="presentation"
    :fill="iconColor"
    data-cy="svg--has-crane">
    <defs>
      <path id="acrane" d="m10.648 8.309v13.332h1.495a.88.88 0 0 1 .876.882.88.88 0 0 1 -.876.882h-1.495v2.783a3.821 3.821 0 0 1 3.212 2.815 3.842 3.842 0 0 1 -.382 2.907 3.804 3.804 0 0 1 -2.313 1.79c-.743.2-1.497.163-2.182-.066a3.822 3.822 0 0 1 -1.795-1.265.882.882 0 0 1 .144-1.233.869.869 0 0 1 1.225.144 2.041 2.041 0 0 0 2.155.717c.552-.148.99-.505 1.253-.962.263-.46.352-1.022.204-1.578a2.064 2.064 0 0 0 -1.986-1.537.88.88 0 0 1 -1.288-.779v-3.736h-1.495a.88.88 0 0 1 -.876-.882.88.88 0 0 1 .876-.882h1.495v-14.527l-3.508-2.392-.002.003a.886.886 0 0 1 -.236-1.222l1.183-2.06-.002-.002a.873.873 0 0 1 1.197-.323l.023.014 24.387 12.992a.876.876 0 0 1 .796-.513h15.057a.88.88 0 0 1 .876.882v13.333a.88.88 0 0 1 -.876.882h-4.145v18.843h6.479a.88.88 0 0 1 .876.882v7.685a.88.88 0 0 1 -.876.882h-32.801a.88.88 0 0 1 -.877-.882v-7.685a.88.88 0 0 1 .877-.882h19.555v-18.843h-4.145a.88.88 0 0 1 -.876-.882v-5.056l-21.209-14.46zm-.562-2.505a.878.878 0 0 1 .328.224l21.443 14.62v-4.575l-24.432-13.016-.385.67zm27.668 43.51h-19.554v5.922h31.048v-5.921h-11.494zm.877-1.763h3.26v-18.843h-3.26zm4.138-20.607h4.144v-11.57h-13.303v.186-.03 11.414z"/>
      <mask id="bcrane" fill="#fff">
        <use fill="none" xlink:href="#a"/>
      </mask>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <use :fill="iconColor" :stroke="iconColor" stroke-width=".5" xlink:href="#acrane"/>
      <g :fill="iconColor" mask="url(#bcrane)">
        <path d="m0 0h59.294v59.294h-59.294z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32
    },
    height: {
      type: [Number, String],
      default: 32
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
